/* eslint-disable no-extra-parens,node/no-deprecated-api,no-undef,semi */
;(function () {
  const vueAuthImageSvg = {}
  const axios = typeof require === 'function'
    ? require('axios')
    : window.Axios

  if (!axios) {
    throw new Error('[vue-auth-image-svg] cannot locate Axios')
  }

  /**
   * Delays the request by requestnumber * 500 milliseconds
   * @param config
   * @param requestNumber
   * @returns {Promise<unknown>}
   */
  function delayRequest (config, requestNumber) {
    return new Promise((resolve, reject) => {
      setTimeout(async () => {
        try {
          const response = await axios(config)
          resolve(response)
        } catch (e) {
          reject(e)
        }
      }, 500 * requestNumber)
    })
  }

  /**
   * Makes a deleayed request or returns existing request
   * @param config axios config for request
   * @param requests object with all pending requests
   * @returns {Promise<*>}
   */
  async function makeRequest (config, requests) {
    if (!requests[config.url]) {
      requests[config.url] = delayRequest(config, Object.keys(requests).length)
      return requests[config.url]
    } else {
      return requests[config.url]
    }
  }

  // Adjusted code so it can be reused in dynamic components
  async function setImgSrc (el, binding, requests) {
    if (binding.oldValue === undefined || binding.value !== binding.oldValue) {
      const imageUrl = binding.value
      el.setAttribute('v-auth-image-svg', `'${imageUrl}'`)
      try {
        const resp = await makeRequest({
          method: 'get',
          url: imageUrl
        }, requests)

        el.outerHTML = resp.data
        el.removeAttribute('v-auth-image-svg')
      } catch (error) {
        console.log(error)
      }
    }
  }

  vueAuthImageSvg.install = function (Vue) {
    const requests = {}
    Vue.directive('auth-image-svg', {
      bind: function (el, binding) {
        setImgSrc(el, binding, requests)
      }
    })
  }

  if (typeof exports === 'object') {
    module.exports = vueAuthImageSvg
  } else if (typeof define === 'function' && define.amd) {
    define([], function () {
      return vueAuthImageSvg
    })
  } else if (window.Vue) {
    window.vueAuthImageSvg = vueAuthImageSvg
    Vue.use(vueAuthImageSvg)
  }
})()
